window.addEventListener('load', () => {
  const works = document.querySelectorAll('[data-works]')

  if (works.length === 0) return

  works.forEach((work) => {
    const worksControlsPrev = work.querySelector(
      '[data-works-controls="prev"]',
    ) as HTMLButtonElement
    const worksControlsNext = work.querySelector(
      '[data-works-controls="next"]',
    ) as HTMLButtonElement
    const worksSlides = work.querySelectorAll('[data-works-slide]')

    if (!worksControlsPrev || !worksControlsNext || worksSlides.length === 0)
      return

    let currentIndex = 0
    let visibleSlides = 6
    let maxIndex = worksSlides.length - visibleSlides

    // change structure of works on mobile
    const mediaQuery = window.matchMedia('(max-width: 991px)')

    if (mediaQuery.matches) {
      work.classList.add('mobile')
      visibleSlides = 1
      maxIndex = worksSlides.length - visibleSlides
    }

    // init visible slides
    updateVisibleSlides()
    updateButtonStates()

    // change visible slides on resize
    mediaQuery.addEventListener('change', (e) => {
      if (e.matches) {
        visibleSlides = 1
        maxIndex = worksSlides.length - visibleSlides
        work.classList.add('mobile')
        updateVisibleSlides()
        updateButtonStates()
      } else {
        visibleSlides = 6
        maxIndex = worksSlides.length - visibleSlides
        work.classList.remove('mobile')
        updateVisibleSlides()
        updateButtonStates()
      }
    })

    worksControlsPrev.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--
        updateVisibleSlides()
        updateButtonStates()
      }
    })

    worksControlsNext.addEventListener('click', () => {
      if (currentIndex < maxIndex) {
        currentIndex++
        updateVisibleSlides()
        updateButtonStates()
      }
    })

    function updateVisibleSlides() {
      worksSlides.forEach((slide) => slide.classList.remove('active'))

      for (let i = currentIndex; i < currentIndex + visibleSlides; i++) {
        worksSlides[i].classList.add('active')
      }
    }

    function updateButtonStates() {
      if (!worksControlsNext || !worksControlsPrev) return

      worksControlsPrev.disabled = currentIndex === 0
      worksControlsNext.disabled = currentIndex === maxIndex
    }
  })
})
